import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const followingTab = document.querySelector('.followingTab');
const container = document.querySelector('.p-service__contentContainer');

class FollowingTab {
  constructor() {
    this.followingTab();
  }

  followingTab() {
    gsap.from(followingTab, {
      bottom: '-100%',
      autoAlpha: 0,
      duration: 0.3,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: container,
        start: 'top top',
        end: 'bottom bottom',
        onEnter: () => {
          gsap.to(followingTab, {
            bottom: '0',
            autoAlpha: 1,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        },
        onEnterBack: () => {
          gsap.to(followingTab, {
            bottom: '0',
            autoAlpha: 1,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        },
        onLeave: () => {
          gsap.to(followingTab, {
            bottom: '-100%',
            autoAlpha: 0,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        },
        onLeaveBack: () => {
          gsap.to(followingTab, {
            bottom: '-100%',
            autoAlpha: 0,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        },
      },
    });
  }
}
export default FollowingTab;
